import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { property as t } from "./property.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function r(r) {
  return t(_objectSpread(_objectSpread({}, r), {}, {
    state: !0,
    attribute: !1
  }));
}
export { r as state };
//# sourceMappingURL=state.js.map